import { S, save } from './state';
import { $ } from './util';

export const tut = {step:0, t:0};
export function hintShow(t){ $('#hint').innerHTML = t; $('#hint').classList.add('on'); }
export function hintOff(){ $('#hint').classList.remove('on'); }
export function updateTutorial(dt){
  if (!save.settings.hints || S.mode==='world' || S.mode==='campaign' && S.level>0) { hintOff(); return; }
  tut.t += dt;
  const steps: Array<[() => boolean, () => boolean, string]> = S.keyboard ? [
    [() => tut.t > 1.5, () => tut.t > 6, 'Mouse aims · hold <kbd>Space</kbd> to fire · <kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd> walks'],
    [() => S.destroyed >= 1, () => S.destroyed >= 3, 'Drop buildings within 3 seconds of each other for a chain multiplier'],
    [() => S.hammerCd <= 0 && S.destroyed >= 2, () => S.hammer || S.hammerCd > 0, '<kbd>1</kbd> HAMMER is ready · aim and press it'],
  ] : [
    [() => tut.t > 1.5, () => !S.glassesOn, 'Look at a building. Take the sunglasses off.'],
    [() => S.hold > 1.5, () => S.blink || S.glassesOn, 'Blink to cut the beam · lenses back on to recharge'],
    [() => S.destroyed >= 1, () => S.destroyed >= 3, 'Drop buildings within 3 seconds of each other for a chain multiplier'],
    [() => S.juice < 35, () => S.juice > 60, 'Low juice · walk over an amber gem for +30 · big towers drop them'],
    [() => S.hammerCd <= 0 && S.destroyed >= 2, () => S.hammer || S.hammerCd > 0, 'HAMMER ready · hold a fist up to the camera · aim with the reticle'],
  ];
  if (tut.step >= steps.length) return;
  const [show, done, text] = steps[tut.step];
  if (done()){ hintOff(); tut.step++; tut.t = 0; return; }
  if (show()) hintShow(text);
}
